// src/api/openaiProxy.js
// Frontend -> backend proxy wrappers.
// IMPORTANT: Never put OPENAI_API_KEY in frontend.
// These call your Express backend at localhost:3001.

// ❌ Node backend removed
const BASE = null;

export async function postJson(path, body) {
  const r = await fetch(`${BASE}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body || {}),
  });

  const text = await r.text().catch(() => "");
  if (!r.ok) {
    throw new Error(`POST ${path} failed: ${r.status} ${text}`);
  }

  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

// ----------------------------
// Image features (YOU HAVE THIS)
// ----------------------------

// Raw JSON: { items: [...], palette: {...} }
export async function extractImageFeatures(imageUrl) {
  // ❌ removed — handled by backend on edit save
  return null;
}

// Caption-style string for ranking (derived from extractImageFeatures)
export async function describeImage(imageUrl) {
  // ❌ removed — no longer needed
  return null;
}

// ----------------------------
// Embeddings / intent (STUBS for now)
// ----------------------------

// 1) embedText(text) -> number[] embedding
// Stub returns null so app compiles until you add a backend embed endpoint.
export async function embedText(text) {
  const t = String(text || "").trim();
  if (!t) return null;

  // When ready, wire backend:
  // const json = await postJson("/api/embed-text", { text: t });
  // return json?.embedding || json; // depending on your backend shape

  return null;
}

// 2) extractIntent(query) -> { constraints: { categories?:[], colors?:[] } } | null
export async function extractIntent(query) {
  const q = String(query || "").trim();
  if (!q) return null;

  // When ready, wire backend:
  // return await postJson("/api/extract-intent", { query: q });

  return null;
}